export default "__VITE_ASSET__3ysO66ud__"